import React, { useState } from 'react';
import { InformePericial, FaseInforme } from '../../types';
import { informeService } from '../../services/api';
import { FiMail } from 'react-icons/fi';
import './EncargoForm.css';

interface EnviarInformeProps {
    informe?: InformePericial;
    onUpdate: (informe: InformePericial, targetFase?: FaseInforme) => void;
}

const EnviarInforme: React.FC<EnviarInformeProps> = ({ informe, onUpdate }) => {
    const [email, setEmail] = useState('');
    const [sending, setSending] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const prvHandleSiguienteFase = async () => {
        if (!informe) return;
        let updatedInforme = informe;
        try {
            const res = await informeService.cambiarFase(informe.id, 'cerrado');
            updatedInforme = res.data;
        } catch (e) {
            console.error('Error al cambiar de fase:', e);
        }
        onUpdate(updatedInforme, 'cerrado');
    };

    const prvHandleSend = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!informe || !email) return;

        setSending(true);
        setError('');
        setSuccess('');

        try {
            await informeService.enviarInformeEmail(informe.id, email);
            setSuccess('Informe enviado correctamente.');
        } catch (err: any) {
            console.error('Error al enviar informe:', err);
            setError(err.response?.data?.error || 'Error al enviar el informe');
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="encargo-form">
            <div className="form-header-section flex justify-between items-center mb-4">
                <div>
                    <h3 className="section-title mb-1">Enviar Informe Final</h3>
                    <p className="text-sm text-secondary">
                        Envía el informe pericial revisado al destinatario final.
                    </p>
                </div>
                {informe && (
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={prvHandleSiguienteFase}
                    >
                        Siguiente Fase
                    </button>
                )}
            </div>

            {error && <div className="error-message mb-4">{error}</div>}
            {success && <div className="success-message mb-4 p-4 bg-green-50 text-green-700 border border-green-200 rounded">{success}</div>}

            <form onSubmit={prvHandleSend} className="form-section max-w-lg mx-auto bg-white p-8 rounded-lg border border-gray-200 shadow-sm mt-8">
                <div className="text-center mb-6 text-gray-400">
                    <span className="text-4xl block mb-2"><FiMail /></span>
                    <h4 className="font-medium text-gray-900">Detalles de Envío</h4>
                </div>

                <div className="form-group mb-6">
                    <label className="block mb-2 font-medium">Correo Electrónico del Destinatario</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="ejemplo@aseguradora.com"
                        className="input w-full p-3"
                        required
                    />
                </div>

                <button
                    type="submit"
                    className="btn btn-primary w-full justify-center py-3 text-lg"
                    disabled={sending || !email}
                >
                    {sending ? 'Enviando...' : 'Enviar Informe'}
                </button>
            </form>
        </div>
    );
};

export default EnviarInforme;
